<template>
  <main class="l-main p-contentplans">
    <TitleMain
      icon="contentplans"
      faq="/sections/360001240075"
      howTo="/sections/4404626250255"
    >
      <span class="title">コンテンツ立案</span>
      <span class="description">
        検索上位コンテンツの内容やチャットAIが提供する情報を基に、<br />
        上位を目指せる＝ユーザーにとって価値があるコンテンツを作成しましょう。
      </span>
    </TitleMain>
    <div class="l-container">
      <AiWritingBanner :projectId="project.id" />
      <div class="l-toolBlock">
        <ButtonToProjects />
        <Button
          v-if="$route.name != 'contentPlans'"
          :to="{
            name: 'contentPlans'
          }"
          variant="light"
          icon="pageback"
          radius
        >
          コンテンツ立案一覧に戻る
        </Button>
        <Breadcrumb />
      </div>
      <div class="l-block">
        <FormAddKeyword
          :createdAt="createdAt"
          :keyword="keyword"
          :project="project"
        />
      </div>
      <ul class="c-tab--balloon l-my-6">
        <li class="c-tab--balloon__item">
          <router-link
            :to="{
              name: 'contentPlansSurvey',
              query: { createdAt: createdAt, keyword: keyword }
            }"
            class="c-tab--balloon__link"
            :class="{ 'is-noevent': isTopPage }"
            exact
          >
            <Icon variant="survey" :size="20" />
            コンテンツ調査
          </router-link>
        </li>
        <li class="c-tab--balloon__item">
          <router-link
            :to="{
              name: 'contentPlansWriting',
              query: { createdAt: createdAt, keyword: keyword }
            }"
            class="c-tab--balloon__link"
            :class="{ 'is-noevent': isTopPage }"
          >
            <Icon2 variant="contentPlans" :size="17.5" />
            タイトル・見出し設計
          </router-link>
        </li>
      </ul>
      <router-view
        :createdAt="createdAt"
        :keyword="keyword"
        :project="project"
      />
    </div>
  </main>
</template>

<script>
import AiWritingBanner from '@/components/aiWriting/AiWritingBanner';
import Breadcrumb from '@/components/Breadcrumb';
import Button from '@/components/Button';
import ButtonToProjects from '@/components/ButtonToProjects';
import FormAddKeyword from '@/components/contentPlans/FormAddKeyword';
import Icon from '@/components/Icon';
import Icon2 from '@/components/Icon2';
import TitleMain from '@/components/TitleMain';

export default {
  props: {
    createdAt: {
      type: String,
      required: false
    },
    keyword: {
      type: String,
      required: false
    },
    project: {
      type: Object,
      required: true
    }
  },
  components: {
    AiWritingBanner,
    Breadcrumb,
    Button,
    ButtonToProjects,
    FormAddKeyword,
    Icon,
    Icon2,
    TitleMain
  },
  computed: {
    isTopPage() {
      return this.$route.name === 'contentPlans';
    }
  }
};
</script>
